pageId = 'page-users_signup_guide'
page = "##{pageId}"

$ ->
  if $('.page').is page
    switch simple.url().search.message
      when 'dingtalk_already_binded' then message = '钉钉账号已绑定过 Tower 账号，请更换后再试。'
      when 'user_already_binded' then message = '你已经绑定过了，直接进入 Tower 使用吧。'

    simple.dialog.message content: message if message

    bindWechat()

  $(document).on 'click', '.rebind-wechat-sheet .btn-action-dismiss', (e) ->
    simple.dialog.removeAll()

bindWechat = ->
  $.ajax
    url: "/wechat/qrcode/?type=#{ $('input[name=qrcode_type]').val() }"
    type: 'get'
    dataType: 'json'
    success: (result) ->
      if result.success
        $('img#wechat-qrcode').attr 'src', result.qrcode_url
        channel = tower.tempPusher(result.channel)
        channel.bind 'pusher:subscription_succeeded', ->
          $('.qrcode-wrap').removeClass('loading')
        .bind 'WECHAT_ONLY_BIND', (result) ->
          if result.success
            $.post '/users/bind_wechat_on_register'  # KPI: 统计注册绑定
            location.href = '/launchpad'
          else if !result.success && result.please_rebind
            dialog = simple.dialog
              content: $('#signup-guide-bind-wehcat').html()
              cls: 'dialog-rebind-wechat'
              width: 400
              buttons: null

            $rebindWechatSheet = dialog.el.find('.rebind-wechat-sheet')
            $rebindWechatSheet.find('.error-desc').html(result.message)
            $rebindWechatSheet.find('.btn-action-rebind').val("解绑「#{result.previous_bind_email}」，并重新绑定到当前账号")

            dialog.el.find('.form-action-rebind').on 'ajax:success', (e, result) ->
              return unless result.success
              dialog.remove()
              $.post '/users/bind_wechat_on_register'  # KPI: 统计注册绑定
              location.href = '/launchpad'
          else
            simple.dialog.message
              content: result.message
